"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxSaveGlobalApplicationPersonalizationSettingsArgs = void 0;
function serializeHxSaveGlobalApplicationPersonalizationSettingsArgs(_arg) {
    var output = [];
    output.push(_arg.shouldSetAccentColor);
    output.push(_arg.accentColor);
    output.push(_arg.shouldSetTheme);
    output.push(_arg.theme);
    output.push(_arg.shouldSetBackgroundMode);
    output.push(_arg.backgroundMode);
    output.push(_arg.shouldSetBackgroundImage);
    output.push(_arg.backgroundImage);
    return output;
}
exports.serializeHxSaveGlobalApplicationPersonalizationSettingsArgs = serializeHxSaveGlobalApplicationPersonalizationSettingsArgs;
